import { Directive, HostListener, Input } from '@angular/core';
import { ClipboardService } from '@app/services/clipboard.service';

@Directive({ selector: '[synCopyToClipboard]' })
export class CopyToClipboardDirective {
    @Input() synCopyToClipboard: string;

    constructor(private readonly clipboardService: ClipboardService) {}

    @HostListener('click') onClick() {
        this.clipboardService.copy(this.synCopyToClipboard);
    }
}
